import createCachedSelector from 're-reselect'
import { selectBillingUsage } from './selectBillingUsage'
import { pricingIdToComponents } from '../util'
import { selectPlans } from './selectPlans'

export const selectQuantityForPricingId = createCachedSelector(
  (_state, currentPricingId) => currentPricingId,
  selectPlans,
  selectBillingUsage,
  (pricingId, plans, usage) => {
    const { product, planId } = pricingIdToComponents(pricingId)
    const plan = plans.find(p => p.product === product && p.planId === planId)

    if (plan.pricingModel === 'flat') {
      return 1
    } else if (product === 'inbox') {
      return usage.inbox.users
    } else if (product === 'kb') {
      return usage.inbox.kbs
    }
    return null
  }
)((_state, pricingId) => pricingId || 'unknown')
